<template>
  <div>
    <v-btn v-if="!showList" color="info" class="mx-0" @click="showArchiveList(1)">
      <v-icon>rate_review</v-icon> See Archive List
    </v-btn>

    <div v-if="showList">
        <v-card-title>            
          <h2>Archive List</h2>
          <v-spacer></v-spacer>
          <v-text-field append-icon="search" label="Search" single-line hide-details v-model="search"></v-text-field>      
        </v-card-title>


        <span style="display:none;">{{serial=serialNumber}}</span>
        <v-data-table
          :headers="headers"
          :items="desserts"
          :pagination.sync="pagination"
          :total-items="totalDesserts"
          :loading="loading"
          class="elevation-4"      
        >
          <template slot="items" slot-scope="props">
            <td class="text-xs-left">{{serial++}}</td>
            <td class="text-xs-left">{{ props.item.budget_category }}</td>
            <td class="text-xs-left">{{ props.item.budgeting_year }}</td>
            <td class="text-xs-left">{{ changeFormateDMY(props.item.start_date) }}</td>
            <td class="text-xs-left">{{ changeFormateDMY(props.item.end_date) }}</td>
            <td class="text-xs-left">{{ props.item.document_name }}</td>                          

            <td class="text-xs-left">
              <v-btn v-if="props.item.projectDoc_id" icon class="mx-0" @click="downloadFile(props.item.document_file_name)">
                <v-icon color="purple">image</v-icon>
              </v-btn>
              <v-btn v-else icon disabled class="mx-0" title="Empty File">
                <v-icon color="purple">image</v-icon>
              </v-btn>
            </td>

            <td class="text-xs-left">         
            <span v-if="props.item.is_active" class="active">Yes</span>           
            <span v-else class="in-active">No</span>            
            </td> 
            <td style="color:green; font-weight:bold;">Revised</td> 
            <td class="text-xs-left">{{ props.item.modified_date }}</td>

            <td class="justify-center layout px-0">
              <v-btn icon class="mx-0" @click="viewDetails(props.item.id)">
                <v-icon color="teal">remove_red_eye</v-icon>
              </v-btn>
            </td>
          </template>
        </v-data-table>
      </div>
  </div>
</template>


<script>
const commonService = require("../../../services/common.service");
import Axios from "axios";
import ServerPath from "../../../server-path/server-path";

export default {

  data: () => ({
    showList: false,

    /*------------- Datatable ---------------*/
    serialNumber: 0,
    sort: "",
    queryData: {
      sortBy: "id",
      descending: true,
      page: 1,
      rowsPerPage: 5,
      totalItems: 0,
      search_val: ""
    },

    search: "",
    totalDesserts: 0,
    desserts: [],
    loading: true,
    pagination: {},

    headers: [
      {
        text: "SL",
        value: ""
      },
     
      {
        text: "Budget Category",
        align: "left",
        sortable: true,
        value: "budget_category"
      },
      {
        text: "Budgeting Year",
        align: "left",
        sortable: true,
        value: "budgeting_year"
      },
      {
        text: "Start Date",
        align: "left",
        sortable: true,
        value: "start_date"
      },
      { text: "End Date", align: "left", sortable: true, value: "end_date" },
      {
        text: "Related Document",
        align: "left",
        sortable: true,
        value: "document_name"
      },

      {
        text: "Upload File",
        align: "left",
        sortable: true,
        value: "upload_file_name"
      },

      {text: "Active", align: "left", sortable: true, value: "is_active"},
      { text: "Status", align: "center", value: "" },
      {text: "Revised Date", align: "left", sortable: true, value: "modified_date"},

      { text: "Action", align: "center", value: "" }
    ],
    /*------------- /Datatable ---------------*/
    formSchema: {
      id: 0,
      inception_date:"",
      closing_date:"",
      budget_date: "",
      document_name: "",      
      budget_category:"",
      revision:0,
      projectDoc_id:0,
      document_file_name:'',
    }
  }),

  /*------------Datatable------------*/

  watch: {
    params: {
      handler() {
        this.getDataFromApi().then(data => {
          this.desserts = data.items;
          this.totalDesserts = data.total;
        });
      },
      deep: true
    }
  },

  computed: {
    params(nv) {
      return {
        ...this.pagination,
        query: this.search
      };
    }
  },
  /*------------/Datatable------------*/

  methods: {
    showArchiveList(action){
      this.showList = false
      if(action == 1)
      {
        this.showList = true
        this.getDataFromApi().then(data => {
          this.desserts = data.items;
          this.totalDesserts = data.total;
        });    
      }
    },

    viewDetails(id){
      let route = ServerPath.serverPath+'/yearly-pro-budget-archive/'+id;
      window.open(route, '_blank');
    },

    getDataFromApi() {
      this.loading = true;
      return new Promise((resolve, reject) => {
        const { sortBy, descending, page, rowsPerPage } = this.pagination;
        let search = this.search.trim().toLowerCase();

        let query_Data = this.queryData;

        (query_Data.sortBy = "id"),
          (query_Data.descending = this.pagination.descending),
          (query_Data.page = this.pagination.page),
          (query_Data.rowsPerPage = this.pagination.rowsPerPage),
          (query_Data.search_val = this.search),
          (query_Data.tbl = 'archive');

        const serialNumber =
          this.pagination.rowsPerPage * this.pagination.page -
          this.pagination.rowsPerPage;
        this.serialNumber = serialNumber + 1;

        commonService
          .getServerSideData(query_Data, "yearly-project-budget-list-archive")
          .then(res => {
            let items = res.data;

            const total = res.totalRecords;
            if (search) {
              items = items.filter(item => {
                return Object.values(item)
                  .join(",")
                  .toLowerCase()
                  .includes(search);
              });
            }

            if (this.pagination.sortBy) {
              items = items.sort((a, b) => {
                const sortA = a[sortBy];
                const sortB = b[sortBy];

                if (descending) {
                  if (sortA < sortB) return 1;
                  if (sortA > sortB) return -1;
                  return 0;
                } else {
                  if (sortA < sortB) return -1;
                  if (sortA > sortB) return 1;
                  return 0;
                }
              });
            }

            setTimeout(() => {
              this.loading = false;
              resolve({
                items,
                total
              });
            }, 300);
          });
      });
    },

    downloadFile(fileName) {
      let url = ServerPath.serverPath+fileName;
      window.open(url);      
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/components/project_info/yearly_project_budget/yearlyDataTableArchive.vue